
// src/web/components/diary-content.jsx

import React from 'react'
import ReactDOM from 'react-dom'
import connect from '../../connects/diary-content'
import { themr } from 'react-css-themr'
import classnames from 'classnames'
import diaryTheme from './themes/diary.css'
import { translate } from 'react-i18next'
import pureRender from 'pure-render-decorator'
import ToggleButton from './toggle-button.jsx'
import {
  CardText,
} from 'react-toolbox/lib/card'
import { convertEmojiHTML } from '../../helpers/emoji-helpers'
import { urlRegex } from '../../helpers/url-regexp'
import isGoogleDocUrl from '../../helpers/google-doc'
import isGambaUrl from '../../helpers/gamba-url'
import GoogleIcons from '../../assets/google-icons'
import _ from 'lodash'

const UrlRegex = urlRegex()
const MAX_LINES = { isPhone: 10, isPC: 30 }

@themr('Diary', diaryTheme)
class DiaryContent extends React.Component {
  state = {}

  setContentHeight = (props)=> {
    if (props.content && props.content.match(/<span class=['"]stamp [-a-zA-Z0-9]+["']><\/span>/))
      return

    var content = ReactDOM.findDOMNode(this.contentRef)

    // Check if there is searchHits, view all content
    if (props.searchHits) {
      this.setState({ showAll: 'show' })
      content.style.maxHeight = 'none'
      return
    }

    var maxHeight = 10 * (props.profile ? 10 : props.comment ? 3 : MAX_LINES[props.isPhone ? 'isPhone' : 'isPC'])
    if (content != null && content.clientHeight >= maxHeight) {
      this.setState({ showAll: 'hide' })
      content.style.maxHeight = maxHeight + 'px'
    }else{
      this.setState({ showAll: undefined })
    }
  }

  toggleShow = ()=> this.setState({ showAll: this.state.showAll == 'hide' ? 'show' : 'hide' })

  componentDidMount() {
    this.setContentHeight(this.props)
    var googleDocElements = ReactDOM.findDOMNode(this.component).querySelectorAll('.googleDoc, .googleDocIcon')
    _.each(googleDocElements, (element)=> {
      element.onclick = (event)=> {
        event.preventDefault()
        this.props.showGoogleDoc(element.href)
      }
    })
  }

  componentDidUpdate(prevProps) {
    if (this.props.content != prevProps.content) {
      this.setContentHeight(this.props)
    }
    var googleDocElements = ReactDOM.findDOMNode(this.component).querySelectorAll('.googleDoc, .googleDocIcon')
    _.each(googleDocElements, (element)=> {
      !element.onclick && (
        element.onclick = (event)=> {
          event.preventDefault()
          this.props.showGoogleDoc(element.href)
        }
      )
    })
  }

  renderGoogleDocUrl = (url)=> {
    const urlLink = this.props.urlLinks && this.props.urlLinks[url]
    const image_url = urlLink && (urlLink.image_url || GoogleIcons[urlLink.mime_type || 'default'] || GoogleIcons['default'])
    var title = urlLink && urlLink.title || this.props.t('label:Googleドキュメント')
    title = title && title.length > 20 ? title.slice(0, 20) + "..." : title
    return `<div><a class=${image_url ? "googleDoc" : "googleDocIcon" } style="background: #E8E8E8; border-radius: 5px; padding: 3px 7px; text-decoration: none; font-size: 90%; display: inline-block; vertical-align: middle; height: 24px; margin-top: 1px;" href="${url}">`+
      (image_url ? `<img src=${image_url} style="height: 18px; vertical-align: middle;">` : '')+
      `&nbsp;${title}</a></div>`
  }
  renderLink = (url)=> {
    const urlLink = this.props.urlLinks && this.props.urlLinks[url]
    const image_url = urlLink && urlLink.image_url
    var title = urlLink && urlLink.title || isGambaUrl(url) && this.props.t('label:gambaで開く')
    title = title && title.length > 20 ? title.slice(0, 20) + "..." : title
    var disp_url = (url.length > 40 ? url.slice(0, 40) + "..." : url).replace(/^https?:\/\/(www\.)?/, '')
    const target = isGambaUrl(url) ? '' : 'target="_blank"'
    if (!title) {
      title = disp_url
      disp_url = undefined
    }
    if (isGambaUrl(url))
      disp_url = undefined
    return `<div style="display: ${!image_url && "inline-block;"}"><a ${target} class=${image_url ? "image" : "materialIcon"} rel="noopener noreferrer" style="background: #E8E8E8; border-radius: 5px; margin-top: 10px; margin-bottom: 10px; display: ${image_url ? "inline-block" : "flex"}; vertical-align: middle; text-decoration: none; padding: 0px 5px 0px 0px; height: ${disp_url ? '32px' : '24px'};" href="${url}">` +
        '<div style="display: flex; align-items: center;">' +
          (image_url ? `<img src="${image_url}" style="height: ${disp_url ? '32px' : '24px'}; border-radius: 5px; margin-right: 3px 5px;"/>` : '')+
          '<div style="display: flex; flex-direction: column; margin-left: 2px; text-indent: initial; line-height: 95%;">'+
            `<div style="font-size: 90%">${title}</div>`+
            (disp_url ? `<div style="font-size: 80%; color: #666;">${disp_url}</div>` : '')+
          '</div>'+
        '</div>'+
      '</a></div>'
  }

  render() {
    const {
      t,
      content,
      isPhone,
      theme,
      comment,
      searchHits,
      showGoogleDoc,
      urlLinks,
      modalContent,
      profile,
    } = this.props

    const className = classnames(theme.content, { all: this.state.showAll == 'show', comment: this.props.comment,  profile: this.props.profile })
    const modalClassName = classnames(theme.content, { modal: this.state.showAll == 'show' })

    var htmlContent = convertEmojiHTML(content.replace(UrlRegex, (match)=> {
      return isGoogleDocUrl(match) && this.renderGoogleDocUrl(match) || this.renderLink(match)
    }))

    searchHits && _.each(searchHits, (hit) => {
      // Escaping any special regex characters in the hit string to prevent regex errors
      const escapedHit = hit.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      // Regex pattern to avoid matching `hit` inside HTML tags while performing a global case-insensitive search
      const regexPattern = new RegExp(`(?!<[^>]*?)(${escapedHit})(?![^<]*?>)`, 'gi');

      htmlContent = htmlContent.replace(regexPattern, `<em>$1</em>`);
    })

    var Component = this.props.component || CardText

    return (
      <Component theme={diaryTheme} ref={(component)=> this.component = component}>
        <div ref={(content)=> this.contentRef = content} className={modalContent ? modalClassName : className}>
          <div className={diaryTheme.itemText} dangerouslySetInnerHTML={{__html: htmlContent}} />
        </div>
        {!searchHits && this.state.showAll && 
          <ToggleButton
              className="fluid"
              flag={this.state.showAll == 'hide'}
              onClick={this.toggleShow} />}
      </Component>
    )
  }
}

export default connect(DiaryContent)



// WEBPACK FOOTER //
// ./src/web/components/diary-content.jsx